import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const FOOTER_DESCRIPTION = "D-Right Technologies (Pvt) Ltd is a healthcare technology company partnering with ClinTa Healthcare (USA) to support Pakistan's healthcare sector.";
const COMPANY_LINKS = [
  { to: "/company-overview", label: "Company Overview" },
  { to: "/leadership-advisors", label: "Leadership & Advisors" },
];
const PRODUCT_LINKS = [
  { to: "/web-builder", label: "Web Builder" },
  { to: "/laris", label: "LARIS" },
  { to: "/maps", label: "MAPS" },
];
const SUPPORT_LINKS = [
  { to: "/contact-us", label: "Contact Us" },
  { to: "/request-a-demo", label: "Request a Demo" },
  { to: "/faqs", label: "FAQs" },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <div>
      <footer className="footer-trust-badge pt-60 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-5 mb-4 mb-lg-0">
              <a href="#" className="navbar-brand mb-3 d-block">
                <img src="/assets/logo.png" alt="logo" className="img-fluid" />
              </a>
              <p>{FOOTER_DESCRIPTION}</p>
            </div>
            <div className="col-12 col-lg-7">
              <div className="row">
                <div className="col-6 col-md-4 mb-4 mb-md-0">
                  <h6 className="text-uppercase small">About</h6>
                  <ul>
                    {COMPANY_LINKS.map((l) => (
                      <li key={l.to}>
                        <Link to={l.to}>{l.label}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-6 col-md-4 mb-4 mb-md-0">
                  <h6 className="text-uppercase small">Solutions</h6>
                  <ul>
                    {PRODUCT_LINKS.map((l) => (
                      <li key={l.to}>
                        <Link to={l.to}>{l.label}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-6 col-md-4">
                  <h6 className="text-uppercase small">Support</h6>
                  <ul>
                    {SUPPORT_LINKS.map((l) => (
                      <li key={l.to}>
                        <Link to={l.to}>{l.label}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom py-3">
          <p className="mb-0 small-text text-center">© {year} ClinTa - Powered by D-Right Technologies.</p>
        </div>
      </footer>

      <div
        className="scroll-top scroll-to-target primary-bg text-white"
        data-target="html"
      >
        <span className="fas fa-hand-point-up"></span>
      </div>
    </div>
  );
}

export default Footer;
